import React from "react";
import { Order } from "../../../../../__generated__/graphql";

interface PreviousOrderCardProps {
  order: Order;
  handleReportClick: (orderId: number) => void;
}

const PreviousOrderCard: React.FC<PreviousOrderCardProps> = ({
  order,
  handleReportClick,
}) => {
  return (
    <li key={order.id} className="bg-white shadow-md rounded-lg p-4 mb-4">
      <div className="flex justify-between">
        <div className="text-2xl font-bold text-gray-600">
          {order.user?.name || "익명의 히어로"}
        </div>
        <div>
          <button
            onClick={() => {
              handleReportClick(order.id);
            }}
            className="flex items-center gap-2 bg-white border-red-500 border text-red-500 px-3 py-1 rounded"
          >
            차단
          </button>
        </div>
      </div>
      <div className="text-xl text-gray-600">
        전화번호: {order?.user?.phone || "없음"}
      </div>
      <div className="text-lg text-gray-500">
        {new Date(order.createdAt).toLocaleString()}
      </div>
      <div className="text-xl text-gray-600">수량: {order.totalQuantity}</div>
      <div
        className={`text-lg ${
          order.isPackConfirmed
            ? "text-green-500"
            : order.isCanceled
            ? "text-red-500"
            : "text-gray-600"
        }`}
      >
        상태:{" "}
        {order.isPackConfirmed ? (
          "확정됨"
        ) : order.isCanceled ? (
          <span className="text-red-500">
            {"취소됨"}
            {order.cancelReason && (
              <span className="text-gray-600">
                {"(취소사유: " + order.cancelReason + ")"}
              </span>
            )}
          </span>
        ) : (
          ""
        )}
      </div>
    </li>
  );
};

export default PreviousOrderCard;
